import { render, staticRenderFns } from "./ProfileConfirm.vue?vue&type=template&id=bc748020&scoped=true&"
import script from "./ProfileConfirm.vue?vue&type=script&lang=js&"
export * from "./ProfileConfirm.vue?vue&type=script&lang=js&"
import style0 from "./ProfileConfirm.vue?vue&type=style&index=0&id=bc748020&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc748020",
  null
  
)

export default component.exports